(function(){
    'use strict';

/**
* @memberof app
* @ngdoc controller
* @name MaterialesController
* @description
* This is main controller
**/ 

    angular
    .module('app')
    .controller('MaterialesController', MaterialesController);

    MaterialesController.$inject = ["GenerallabService","MaterialesService","$timeout","$location",'$anchorScroll'];

    function MaterialesController(GenerallabService,MaterialesService,$timeout,$location,$anchorScroll)
    {

    	var vm = this;
        vm.materiales = [];
    	vm.productosPedidos = [];
        vm.code = 0;
    	vm.loading = false;

    	vm.pedido = [];

        vm.formatDate = function(date){
              var dateOut = new Date(date);
              return dateOut;
        };
        vm.getMateriales = function(){
    		MaterialesService.getMateriales(function(data){
                vm.materiales = data.materiales;
    			vm.productosPedidos = data.productosPedidos;
    		});
        }

        vm.getInclinic = function(){
            MaterialesService.getInclinic(function(data){
                vm.materiales = data.materiales;
            });
        }

        vm.getShop = function(){
            MaterialesService.getShop(function(data){
                vm.materiales = data.materiales;
            });
        }
        vm.addMaterial = function(material){
        	vm.pedido.push(material);
        }

        vm.finalizarPedido = function(){
            vm.code = true;
    		MaterialesService.finalizarPedido(vm.pedido,function(data){
    			vm.code = 1;
    		});

        }

        vm.comprobarMat = function(material){
        	var res = false;
        	for(var cont=0;cont<vm.pedido.length && !res;cont++){
        		if(material.crm_id==vm.pedido[cont].crm_id){
        			res = true;
        		}
        	}
        	//console.log(res);
        	return res;
        }
        
               
    }


})();